// This file was automatically generated from ptdata.letters.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.letters');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.letters.attachments');
goog.require('el8.template.ptdata.patients');
goog.require('el8.template.render.reportFeedItem.referralDetail');
goog.require('el8.template.render.signOff');
goog.require('el8.template.shared.commentReplyForm');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.signedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LetterHeaderWrap"><p class="el8333 el8SingleLineText">To: <span class="el8Bold">');
  el8.template.ptdata.letters.recipient(opt_data, output);
  output.append('</span>');
  el8.template.ptdata.letters.letterStatus(opt_data.letter, output);
  output.append('</p><div class="fr ebs-pull-right"><button type="button" class="el8ShortButton ebs-btn ebs-btn-default ebs-btn-sm letter-toggle-collapse-trigger">show more</button></div><p class="padb5 el8SingleLineText">', (opt_data.letter.subject) ? '<span>Re: ' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.letter.subject) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.subject)) : soy.$$escapeHtml(opt_data.letter.subject))) + '</span>' : (opt_data.letter.isReferralLetter) ? (opt_data.noAttachmentLinks) ? '<span>Referral</span>' : '<a class="item-details-trigger" data-id="' + soy.$$escapeHtml(opt_data.letter.referralOrder.id) + '"><span>Referral</span></a>' : '<span>Re: (no subject)</span>', (opt_data.letter.attachments.length > 0) ? ' <img class="el8PaperClip" src="/static/images/transparent_16x16.png" />' : '', '</p></div>', (opt_data.letter.body) ? (opt_data.letter.isReferralLetter && opt_data.letter.referralOrder) ? '<div class="el8FieldSection"><label class="el8FieldMedium">Reason:</label><div class="letter-body el8FieldMediumLabelPadding el8Wrap el8StandardLineHeight el8StandardFontSize el8SingleLineText">' + soy.$$escapeHtml(opt_data.letter.body) + '</div></div>' : '<div class="el8FieldSection"><p class="letter-body el8SingleLineText mt10 mb20">' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.letter.body) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.body)) : soy.$$escapeHtml(opt_data.letter.body))) + '</p></div>' : '', '<div class="letter-collapsible-section ebs-form-horizontal"><div class="mb20">');
  if (opt_data.letter.isReferralLetter && opt_data.letter.referralOrder) {
    el8.template.render.reportFeedItem.referralDetail.contentReferralOrderDetail({authNumber: opt_data.letter.referralOrder.authNumber, authorizationFor: opt_data.letter.referralOrder.authorizationFor, icd10CodeObjs: opt_data.letter.referralOrder.icd10CodeObjs, icd9CodeObjs: opt_data.letter.referralOrder.icd9CodeObjs}, output);
  }
  output.append('</div>');
  if (opt_data.excludeAttachmentDetails) {
    output.append('<div class="padv5"><p class="el8AttachmentListChart el8GrayText el8ItalicText">', soy.$$escapeHtml(opt_data.letter.attachments.length), ' attachment', (opt_data.letter.attachments.length != 1) ? 's' : '', ' (see chart for details)</p></div>');
  } else if (opt_data.letter.attachments.length) {
    output.append('<p class="el8SmallHeading">Attachments</p>');
    el8.template.ptdata.letters.attachmentSection(soy.$$augmentData(opt_data.letter, {noAttachmentLinks: opt_data.noAttachmentLinks}), output);
  }
  if (opt_data.letter.signedUnreadNotifications && opt_data.letter.signedUnreadNotifications.length || opt_data.letter.signedUnreadAlertDate) {
    output.append('<div class="letter-unread-notifications-section el8DeliverySection mt10 mb5"><p class="el8SmallHeading">Delivery Details</p>');
    el8.template.ptdata.letters.unreadNotifications({letter: opt_data.letter}, output);
    output.append('</div>');
  }
  output.append('<div>');
  el8.template.render.signOff.summary(opt_data.letter, output);
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.reqActSummaryUnsigned = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.letter.isReferralLetter) {
    el8.template.ptdata.letters.reqActSummaryUnsignedReferralLetter(opt_data, output);
  } else {
    el8.template.ptdata.letters.reqActSummaryUnsignedGenericLetter(opt_data, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.reqActSummaryUnsignedReferralLetter = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Referral');
  if (opt_data.letter.displayTo) {
    output.append(' to ');
    el8.template.ptdata.letters.recipient(soy.$$augmentData(opt_data, {noHighlight: true}), output);
  }
  output.append((opt_data.letter.body) ? ' for: ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.body)) : soy.$$escapeHtml(opt_data.letter.body)) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.reqActSummaryUnsignedGenericLetter = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Letter');
  if (opt_data.letter.isSendToPatient || opt_data.letter.displayTo) {
    output.append(' to ');
    el8.template.ptdata.letters.recipient(soy.$$augmentData(opt_data, {noHighlight: true}), output);
  }
  output.append('<p class="el8AppText">Re: ', (opt_data.letter.subject) ? soy.$$escapeHtml(opt_data.letter.subject) : '(no subject)', '</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.feedIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isSendToPatient) ? '<div class="el8FeedItemIconPtLetter"></div>' : (opt_data.isReferralLetter) ? '<div class="el8FeedItemIconReferral"></div>' : '<div class="el8FeedItemIconLetter"></div>', (opt_data.viewedAt || opt_data.patientReadTime) ? '<div class="el8StatusIconSentOpened"></div>' : (opt_data.deliveryMethod == 'emr' || opt_data.deliveryMethod == 'passport' || opt_data.deliveryMethod == 'email') ? '<div class="el8StatusIconSentUnopened"></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.letterMetadataCounts = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8NotesStatusWrap"><ul class="ebs-list-unstyled">', (opt_data.comments.length) ? '<li class="el8NotesStatusItem comments-icon' + ((opt_data.fromPracticeId != el8Globals.PRACTICE_ID && ! opt_data.readTime) ? ' el8Highlight' : '') + '"><span class="el8IconResponses"></span><span class="el8NotesStatusCount">' + soy.$$escapeHtml(opt_data.comments.length) + '</span></li>' : '', '</ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.secondarySection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.letter.isCommentsAllowed) {
    output.append('<div class="el8ResponsesSection letter-responses-section mb5">');
    el8.template.ptdata.letters.commentSection(soy.$$augmentData(opt_data.letter, {noHighlight: opt_data.noHighlight}), output);
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.unreadNotifications = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.letter.signedUnreadAlertDate) ? '<p><span class="el8NotificationIcon"></span>To be notified if not opened by ' + (soy.$$escapeHtml(opt_data.letter.signedUnreadAlertDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.letter.signedUnreadAlertDate)) : '') + '</p>' : '');
  if (opt_data.letter.signedUnreadNotifications && opt_data.letter.signedUnreadNotifications.length) {
    var summaryList19315 = opt_data.letter.signedUnreadNotifications;
    var summaryListLen19315 = summaryList19315.length;
    for (var summaryIndex19315 = 0; summaryIndex19315 < summaryListLen19315; summaryIndex19315++) {
      var summaryData19315 = summaryList19315[summaryIndex19315];
      output.append('<p class="el8999">', soy.$$escapeHtml(summaryData19315), '</p>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.commentControls = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.comments.length) {
    output.append('<div class="el8ResponsesHeader"><span class="el8IconResponses"></span><span class="comment-count padl30">');
    el8.template.ptdata.letters.commentCount(opt_data, output);
    output.append('</span></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.commentSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isCommentsAllowed) {
    output.append('<div class="letter-comments">');
    el8.template.ptdata.letters.commentControls(opt_data, output);
    output.append('<ul class="el8ResponsesWrap ebs-list-unstyled">');
    var cList19332 = opt_data.comments;
    var cListLen19332 = cList19332.length;
    for (var cIndex19332 = 0; cIndex19332 < cListLen19332; cIndex19332++) {
      var cData19332 = cList19332[cIndex19332];
      el8.template.ptdata.letters.comment(soy.$$augmentData(cData19332, {noHighlight: opt_data.noHighlight}), output);
    }
    el8.template.shared.commentReplyForm.replyTrigger(opt_data, output);
    output.append('</ul></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.recipient = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.letter.isSendToPatient) {
    el8.template.ptdata.patients.displayName(opt_data.patient, output);
  } else {
    output.append((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.letter.displayTo) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.displayTo)) : soy.$$escapeHtml(opt_data.letter.displayTo)), (opt_data.letter.isReferralLetter && opt_data.letter.referralOrder.specialtyName) ? ' (' + soy.$$escapeHtml(opt_data.letter.referralOrder.specialtyName) + ')' : '', (opt_data.letter.deliveryMethod == 'emr') ? '<span class="el8InlineElationMark"></span>' : (opt_data.letter.deliveryMethod == 'passport') ? '<span class="el8InlinePassportMark"></span>' : (opt_data.letter.deliveryMethod == 'email') ? ' (E: ' + soy.$$escapeHtml(opt_data.letter.emailTo) + ')' : (opt_data.letter.deliveryMethod == 'fax' && opt_data.letter.sendToContactId) ? ' (F: ' + soy.$$escapeHtml(opt_data.letter.toNumber) + ')' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.letterStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isPostDated) {
    output.append('<span class="el8LetterStatus el8LetterUnopened">To be delivered on ', (soy.$$escapeHtml(opt_data.deliveryDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.deliveryDate)) : ''), '</span>');
  } else if (opt_data.deliveryMethod == 'printed') {
  } else if (opt_data.deliveryMethod == 'fax' || opt_data.deliveryMethod == 'passport' && ! opt_data.isSendToPatient) {
    if (opt_data.viewedAt) {
      el8.template.ptdata.letters.openedStatus(opt_data, output);
    } else if (opt_data.isFaxAttachments || opt_data.faxStatus && opt_data.faxStatus != 'success') {
      el8.template.ptdata.letters.faxStatus(opt_data, output);
    } else {
      el8.template.ptdata.letters.openedStatus(opt_data, output);
    }
  } else {
    el8.template.ptdata.letters.openedStatus(opt_data, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.openedStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isSendToPatient || opt_data.deliveryMethod == 'emr' || opt_data.deliveryMethod == 'email') {
    output.append((opt_data.patientReadTime) ? '<span class="el8LetterStatus el8LetterOpened"><span class="el8Bold">Opened</span> on ' + (soy.$$escapeHtml(opt_data.patientReadTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.patientReadTime)) : '') + '</span>' : (opt_data.viewedAt) ? '<span class="el8LetterStatus el8LetterOpened"><span class="el8Bold">Opened</span> on ' + (soy.$$escapeHtml(opt_data.viewedAt)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.viewedAt)) : '') + '</span>' : '<span class="el8LetterStatus el8LetterUnopened"><span class="el8Bold">Unopened</span>: sent ' + ((opt_data.deliveryDate) ? (soy.$$escapeHtml(opt_data.deliveryDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.deliveryDate)) : '') : (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '')) + '</span>');
  } else {
    if (opt_data.viewedAt) {
      output.append('<span class="el8LetterStatus el8LetterOpened"><span class="el8Bold">Opened</span> on ', (soy.$$escapeHtml(opt_data.viewedAt)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.viewedAt)) : ''), '</span>');
    } else if (opt_data.faxStatus == 'failed') {
      el8.template.ptdata.letters.faxStatus(opt_data, output);
    } else {
      output.append('<span class="el8LetterStatus el8LetterUnopened"><span class="el8Bold">Sent</span> ', (opt_data.faxCompleteTime) ? (soy.$$escapeHtml(opt_data.faxCompleteTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.faxCompleteTime)) : '') : (opt_data.faxedAt) ? (soy.$$escapeHtml(opt_data.faxedAt)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.faxedAt)) : '') : (opt_data.deliveryDate) ? (soy.$$escapeHtml(opt_data.deliveryDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.deliveryDate)) : '') : (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''), ' - Attachments Unopened</span>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.faxStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.faxStatus == 'success' && opt_data.faxedAt) ? '<span class="el8LetterStatus el8LetterOpened"><span class="el8Bold">Fax sent</span> ' + ((opt_data.faxCompleteTime) ? (soy.$$escapeHtml(opt_data.faxCompleteTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.faxCompleteTime)) : '') : (soy.$$escapeHtml(opt_data.faxedAt)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.faxedAt)) : '')) + '</span>' : (opt_data.faxStatus == 'failed') ? '<span class="el8LetterStatus el8LetterFailed el8Bold">Failed</span>' : (opt_data.faxStatus == 'pending') ? '<span class="el8LetterStatus el8LetterUnopened el8Bold">Pending</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.reminderBody = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isSendToPatient) ? 'Hi, I would like to follow-up on my last message, since I have not received a response from you yet. Thank you.' : 'Hi, I would like to follow-up on the care for this patient. I have not received a response from your practice yet. Please let me know when you will be seeing the patient. Thank you.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachmentSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol class="padv5 ebs-list-unstyled">');
  var aList19458 = opt_data.attachments;
  var aListLen19458 = aList19458.length;
  for (var aIndex19458 = 0; aIndex19458 < aListLen19458; aIndex19458++) {
    var aData19458 = aList19458[aIndex19458];
    output.append('<li class="el8AttachmentListChart el8StandardFontSize"><img class="el8PaperClip fl ebs-pull-left" src="/static/images/transparent_16x16.png"> ');
    el8.template.ptdata.letters.attachments.savedAttachmentSummary(soy.$$augmentData(aData19458, {noAttachmentLinks: opt_data.noAttachmentLinks, noHighlight: opt_data.noHighlight}), output);
    output.append('</li>');
  }
  output.append('</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.comment = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8ResponsesItem clearfix ', (opt_data.fromPracticeId != el8Globals.PRACTICE_ID && ! opt_data.readTime) ? ' el8Highlight' : '', '">', (opt_data.fromPracticeId != el8Globals.PRACTICE_ID && ! opt_data.readTime) ? '<div class="el8FeedItemNewTag el8ResponseNewTagPosition">NEW</div>' : '', '<p><span class="el8ResponseAuthor', (opt_data.authorStaffType == 'Patient') ? ' el8PatientText' : (opt_data.authorStaffType == 'OfficeStaff') ? ' el8StaffText' : (opt_data.authorStaffType == 'Physician') ? ' el8PhysicianText' : '', '">', (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.authorName) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.authorName)) : soy.$$escapeHtml(opt_data.authorName)), ':</span></p><p><span class="el8Preserve', (opt_data.authorStaffType == 'Patient') ? ' el8PatientText' : (opt_data.authorStaffType == 'OfficeStaff') ? ' el8StaffText' : (opt_data.authorStaffType == 'Physician') ? ' el8PhysicianText' : '', '">', (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.message) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.message)) : soy.$$escapeHtml(opt_data.message)), '</span></p><p><span class="el8ResponseDate">Sent on ', (soy.$$escapeHtml(opt_data.createDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.createDate)) : ''), ' at ', (soy.$$escapeHtml(opt_data.createDate)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.createDate)) : ''), '.</span>', (opt_data.readTime && opt_data.readUserName) ? ' <span class="el8SystemText">Opened on ' + (soy.$$escapeHtml(opt_data.readTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.readTime)) : '') + ' at ' + (soy.$$escapeHtml(opt_data.readTime)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.readTime)) : '') + ' by ' + soy.$$escapeHtml(opt_data.readUserName) + '.</span>' : '', '</p></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.commentCount = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Responses', (opt_data.comments.length) ? ' <span class="el8ResponsesCount">' + soy.$$escapeHtml(opt_data.comments.length) + '</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Letter to', (opt_data.isSendToPatient) ? ' patient' : ' ' + soy.$$escapeHtml(opt_data.displayTo), (opt_data.subject) ? ' re: ' + soy.$$escapeHtml(opt_data.subject) : '', ' ');
  switch (opt_data.deliveryMethod) {
    case 'printed':
      output.append('printed');
      break;
    case 'emr':
      output.append('sent to EMR');
      break;
    case 'passport':
      output.append('sent to Passport');
      break;
    case 'fax':
      output.append('faxed');
      break;
    case 'email':
      output.append('emailed');
      break;
  }
  output.append(' on ', (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.commentQtip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.count == 1) ? 'There is ' + soy.$$escapeHtml(opt_data.count) + ' response' : 'There are ' + soy.$$escapeHtml(opt_data.count) + ' responses', ' to this letter');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.notesQtip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.count == 1) ? 'There is ' + soy.$$escapeHtml(opt_data.count) + ' internal note' : 'There are ' + soy.$$escapeHtml(opt_data.count) + ' internal notes', ' on this letter');
  if (!opt_sb) return output.toString();
};
